<template>
  <v-container fluid>
    <v-layout row wrap justify-space-between>
      <v-flex xs12 sm6 md3 pa-5>
        <AppNumberDisplay
          icon="fas fa-piggy-bank"
          title="Alojados"
          :value="dadosDashboard.plantel"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 pa-5>
        <AppNumberDisplay
          icon="fas fa-book-dead"
          title="Mortalidade"
          :value="dadosDashboard.mortalidadeStr"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 pa-5>
        <AppNumberDisplay
          icon="fas fa-piggy-bank"
          title="Disponíveis"
          :value="dadosDashboard.alojados_lotes_aberto"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 pa-5>
        <AppNumberDisplay
          icon="fas fa-chart-line"
          title="Lotes"
          :value="dadosDashboard.total_lotes_aberto"
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-center mt-5>
      <v-flex xs12 md6 lg6 mt-2 pa-5 v-if="exibeGrafico">
        <v-card
          class="full-height"
          style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;"
          elevation="5"
        >
          <v-toolbar flat>
            <span>Animais disponíveis</span>
          </v-toolbar>
          <DashboardGraph
            :values="dadosDashboard.alojados_lotes_aberto_semana"
            textYAxes="Disponíveis"
          />
        </v-card>
      </v-flex>

      <v-flex xs12 md6 lg6 mt-2 pa-5 v-if="exibeGrafico">
        <v-card
          class="full-height"
          style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;"
          elevation="5"
        >
          <v-toolbar flat>
            <span>Mortalidades</span>
          </v-toolbar>
          <DashboardGraph
            :values="dadosDashboard.baixas_lotes_aberto_semana"
            textYAxes="Mortalidades"
          />
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6 mt-2 pa-5 style="display: grid;">
        <v-card
          class="v-card full-height"
          style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;"
          elevation="5"
        >
          <v-toolbar flat>
            <span>Últimas Mortes</span>
          </v-toolbar>
          <v-data-table
            :headers="headerUltimasMortes"
            @click:row="goToBatch"
            :items="dadosDashboard.ultimas_baixas"
            hide-default-footer
          >
            <template v-slot:item.dtBaixa="{ item }">{{ item.dtBaixa | dateIsoToLocale }}</template>
          </v-data-table>
        </v-card>
      </v-flex>

      <v-flex xs12 md6 mt-2 pa-5>
        <v-card
          class="v-card full-height"
          style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;"
          elevation="5"
        >
          <v-toolbar flat>
            <span>Controle de Mortalidade</span>
            <v-spacer />
            <v-btn
              v-if="!this.$vuetify.breakpoint.xs"
              id="changeGraficoMortalidade"
              fab
              small
              color="info"
              @click="exibeGraficoMortalidade = !exibeGraficoMortalidade"
            >
              <v-icon small v-if="exibeGraficoMortalidade">fa-table</v-icon>
              <v-icon small v-else>fa-chart-area</v-icon>
            </v-btn>
          </v-toolbar>
          <v-layout row wrap>
            <v-flex xs12 md12 sm12 lg12 pa-2 v-if="exibeGraficoMortalidade">
              <DashboardMortalityCausesGraph :values="dadosDashboard.motivos_mortalidade" />
            </v-flex>
            <v-flex pl-3 pr-3 xs12 md12 sm12 lg12 v-else>
              <v-data-table
                :headers="headerMortalidade"
                :items="dadosDashboard.motivos_mortalidade"
                hide-default-footer
              ></v-data-table>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6 mt-2 pa-5>
        <v-card
          class="v-card full-height"
          style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;"
          elevation="5"
        >
          <v-toolbar flat>
            <span>Filtros</span>
          </v-toolbar>
          <v-card-title class="title justify-start">
            <h4>Tipo de Propriedade</h4>
          </v-card-title>
          <v-radio-group v-model="csTipoUep" row wrap class="justify-center">
            <v-layout wrap justify-center>
              <v-flex lg2 xs11 sm11>
                <v-radio key="todas" label="Todas" value="*" color="primary"></v-radio>
              </v-flex>
              <v-flex lg2 xs11 sm11>
                <v-radio key="creche" label="Creche" value="CR" color="primary"></v-radio>
              </v-flex>
              <v-flex lg3 xs11 sm11>
                <v-radio key="wean" label="Wean to Finish" value="WF" color="primary"></v-radio>
              </v-flex>
              <v-flex lg2 xs11 sm11>
                <v-radio key="terminacao" label="Terminação" value="TR" color="primary"></v-radio>
              </v-flex>
              <v-flex lg2 xs11 sm11>
                <v-radio key="upl" label="UPL" value="UP" color="primary"></v-radio>
              </v-flex>
            </v-layout>
          </v-radio-group>
          <v-card-title class="title justify-start">
            <h4>Extensionista</h4>
          </v-card-title>
          <v-layout row wrap justify-center>
            <v-flex lg11 xs11 sm11>
              <v-select
                outlined
                :items="extensionistas"
                v-model="cdResponsavelTecnico"
                itemValue="idResponsavelTecnico"
                itemText="displayName"
                label="Selecione o extensionista por nome ou cpf"
                :menu-props="{ top: true, offsetY: true }"
                clearable
              />
            </v-flex>
          </v-layout>
          <v-layout row justify-center>
            <v-flex md5 sm5 xs2 mb-3>
              <v-spacer />
            </v-flex>
            <v-flex md3 sm3 xs5 mb-3>
              <v-btn id="search" color="primary" rounded @click="filter()">
                <span class="marginSpan">Pesquisar</span>
                <v-icon small>fas fa-search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex md4 sm4 xs2 mb-3>
              <v-spacer />
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AppNumberDisplay from "@/components/layout/AppNumberDisplay.vue";
import DashboardGraph from "@/components/dashboard/DashboardGraph.vue";
import DashboardMortalityCausesGraph from "@/components/dashboard/DashboardMortalityCausesGraph.vue";

import { dateIsoToLocal } from "@/filters/utils.js";

const toMotivosMortalidade = entry => {
  let itemName = entry.itemName != null ? entry.itemName : "Não Informado";
  return { ...entry, itemName };
};

export default {
  components: {
    AppNumberDisplay,
    DashboardGraph,
    DashboardMortalityCausesGraph
  },
  data() {
    return {
      isLoadingDados: false,
      exibeGrafico: false,
      exibeGraficoMortalidade: false,
      headerUltimasMortes: [
        { text: "Lote", value: "lote_producao.jsonProdutor.nmProdutor" },
        { text: "Data", value: "dtBaixa" },
        { text: "Quantidade", value: "qtBaixa" }
      ],
      headerMortalidade: [
        { text: "Motivo", value: "itemName", sortable: false },
        { text: "Quantidade", value: "qtAnimais", sortable: false },
        { text: "Percentual", value: "qtPercent", sortable: false }
      ]
    };
  },
  computed: {
    csTipoUep: {
      get() {
        return this.$store.state.csTipoUepDashboard;
      },
      set(value) {
        this.$store.commit("mtChangeTipoUepDashboard", value);
      }
    },
    cdResponsavelTecnico: {
      get() {
        return this.$store.state.cdResponsavelTecnicoDashboard;
      },
      set(value) {
        this.$store.commit("mtChangeResponsavelTecnicoDashboard", value);
      }
    },
    extensionistas() {
      return this.$store.state.extensionistas;
    },
    dadosDashboard() {
      // eslint-disable-next-line
      this.exibeGrafico = false;

      var dados = this.$store.state.dadosDashboard;
      let mortos = 0;
      if (dados.baixas_lotes_aberto_semana[1]) {
        mortos = dados.baixas_lotes_aberto_semana[1].reduce((acc, val) => {
          return acc + val;
        }, 0);
      }
      dados.mortos = mortos;

      if (dados.baixas_lotes_aberto_semana[0] != null) {
        this.garantirListaGraficoComSeisItens(dados.baixas_lotes_aberto_semana);
      }

      if (dados.alojados_lotes_aberto_semana[0] != null) {
        this.garantirListaGraficoComSeisItens(
          dados.alojados_lotes_aberto_semana
        );
      }

      dados.plantel = dados.alojados_lotes_aberto + dados.mortos;

      dados.mortalidade = 0;
      if (mortos > 0) {
        dados.mortalidade = (dados.mortos / dados.plantel) * 100;
      }
      dados.mortalidadeStr = dados.mortalidade.toFixed(2) + "%";

      if (dados.motivos_mortalidade != undefined) {
        dados.motivos_mortalidade = dados.motivos_mortalidade
          ? dados.motivos_mortalidade.map(toMotivosMortalidade)
          : [];
      }
      // eslint-disable-next-line
      this.exibeGrafico = true;

      return dados;
    }
  },
  methods: {
    dateIsoToLocal,
    loadData() {
      this.exibeGrafico = false;
      this.exibeGraficoMortalidade = false;
      this.isLoadingDados = true;
      let query = {};
      if (this.csTipoUep != "*") {
        query.cs_tipo_uep = this.csTipoUep;
      }
      if (this.cdResponsavelTecnico != undefined) {
        query.cd_responsavel_tecnico = this.cdResponsavelTecnico;
      }
      this.$axios
        .get("dashboard/", { params: query })
        .then(response => {
          this.$store.commit("mtLoadDadosDashboard", response.data[0].data);
          this.exibeGrafico = true;
          if (!this.$vuetify.breakpoint.xs) {
            this.exibeGraficoMortalidade = true;
          }
        })
        .catch(error => {
          this.$store.commit("setSnack", { type: "error", msg: error });
        })
        .finally(() => {
          this.isLoadingDados = false;
        });
    },
    filter() {
      this.loadData();
    },
    graphReloaded() {
      this.reloadMortalityGraph = false;
    },
    goToBatch(value) {
      this.$router.push({
        name: "loteProducao",
        params: { id: value.cdLoteProducao }
      });
    },
    garantirListaGraficoComSeisItens(lista) {
      var list_com_minimo_seis_itens = lista[0];
      while (list_com_minimo_seis_itens.length < 6) {
        list_com_minimo_seis_itens.push(list_com_minimo_seis_itens.length);
        lista[1].push(0);
      }
      lista[0] = list_com_minimo_seis_itens;
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style>
.theme--dark.v-card {
  background: #10303d;
}
.theme--dark.v-sheet {
  background: #10303d;
}
.theme--dark.v-data-table {
  background: #10303d !important;
}

.marginSpan {
  margin: 5px;
}
</style>


